<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv">GUIDE TO THE</a></p><a id="page_xv">
<p class="halftitle1">CONTEMPORARY HARP</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Fm01.vue?3db97c27